<nav
  class="aos-side-menu"
  [class.aos-side-menu_expanded]="expanded"
  [class.aos-side-menu_collapsed]="!expanded"
>
  <div class="aos-side-menu__header">
    <span class="aos-side-menu__logo">
      <img
        ngSrc="./assets/aclara-logo.svg"
        width="32"
        height="32"
        alt="aclara-logo"
        priority
      />
      <img
        class="aos-side-menu__logo-text"
        ngSrc="./assets/aclara-logo-text.svg"
        width="135"
        height="32"
        alt="aclara-logo"
        priority
      />
    </span>
    @if ((hasBreakpointL$ | async) === false) {
      <ui-icon
        class="aos-side-menu__collapse-button"
        [color]="collapseButtonIconColor"
        [name]="collapseButtonIconName"
        [size]="expanded ? collapseButtonExpandedIconSize : collapseButtonCollapsedIconSize"
        (click)="toggleClicked.emit()"
      />
    }
  </div>
  <div class="aos-side-menu__scrollable-container">
    @if (expanded) {
      <aos-side-menu-expanded [menuItems]="(menuItems$ | async)!"> </aos-side-menu-expanded>
    } @else {
      <aos-side-menu-collapsed [menuItems]="(menuItems$ | async)!"> </aos-side-menu-collapsed>
    }
  </div>

  <!-- TODO: Review CSS class and property names. -->
  <div class="aos-side-menu__footer">
    <div>
      <button
        class="aos-side-menu__footer-item"
        (click)="navigateToHelp()"
      >
        <div class="aos-side-menu__footer-item-content">
          <ui-icon
            class="aos-side-menu-item__icon"
            [color]="sideMenuItemIconColor"
            [name]="helpIconName"
            [size]="sideMenuItemIconSize"
          />
          <span class="aos-side-menu-item__text">{{ helpText | translate }}</span>
        </div>
      </button>

      <button
        class="aos-side-menu__footer-item"
        (click)="navigateToAclaraConnect()"
      >
        <div class="aos-side-menu__footer-item-content">
          <ui-icon
            class="aos-side-menu-item__icon"
            [color]="sideMenuItemIconColor"
            [name]="aclaraConnectIconName"
            [size]="sideMenuItemIconSize"
          />
          <span class="aos-side-menu-item__text">{{ aclaraConnectText }}</span>
        </div>
      </button>
    </div>

    <button
      class="aos-side-menu__user-settings-button aos-side-menu__user-name-section"
      (click)="toggleClickUserSettingsSubMenu($event)"
      #userSettingsElement
    >
      <div
        class="aos-side-menu__footer-item-content user-name-section__content"
        (pointerenter)="enterUserSettingsSubMenu($event)"
        (pointerleave)="leaveUserSettingsSubMenu($event)"
      >
        <ui-icon
          class="aos-side-menu-item__icon aos-side-menu__user-avatar-icon"
          [color]="sideMenuItemIconColor"
          [name]="accountAvatarIconName"
          [size]="sideMenuItemIconSize"
        />
        <span
          class="aos-side-menu-item__text aos-side-menu__ellipsis-user-name"
          [class.menu-collapsed]="!expanded"
          [class.menu-expanded]="expanded"
        >
          {{ (userSettings$ | async)?.fullName }}
        </span>
      </div>
      @if (expanded) {
        <div class="aos-side-menu__sub-menu-opener">
          <ui-icon
            class="aos-side-menu__sub-menu-opener__icon"
            [color]="subMenuOpenerIconColor"
            [name]="subMenuOpenerIconName"
            [size]="subMenuOpenerIconSize"
            (click)="toggleClickUserSettingsSubMenu($event)"
          />
        </div>
      }

      @if (showSettingsPopup) {
        <kendo-popup
          class="aos-side-menu-popup"
          popupClass="aos-side-menu-popup__content"
          [anchorAlign]="{ horizontal: 'right', vertical: 'top' }"
          [margin]="{ horizontal: -1, vertical: expanded ? -48 : -35 }"
          [anchor]="userSettingsargetElementRef.nativeElement"
          [animate]="{
            type: 'expand',
            duration: 150,
            direction: 'right'
          }"
          (pointerleave)="leaveUserSettingsSubMenu($event)"
        >
          <button
            class="aos-side-menu__user-settings-button aos-side-menu__button-popup"
            (click)="navigateToUserSettings()"
          >
            <div class="aos-side-menu__footer-item-content aos-side-menu-sub-menu__content">
              <ui-icon
                class="aos-side-menu-item__icon"
                [color]="sideMenuItemIconColor"
                [name]="userSettingsIconName"
                [size]="sideMenuItemIconSize"
              />
              <span class="aos-side-menu-item__text">{{ userSettingsText | translate }}</span>
            </div>
          </button>
          <button
            class="aos-side-menu__user-settings-button aos-side-menu__button-popup"
            (click)="logout()"
          >
            <div class="aos-side-menu__footer-item-content aos-side-menu-sub-menu__content">
              <ui-icon
                class="aos-side-menu-item__icon"
                [color]="sideMenuItemIconColor"
                [name]="logoutButtonIconName"
                [size]="sideMenuItemIconSize"
              />
              <span class="aos-side-menu-item__text">{{ logoutText | translate }}</span>
            </div>
          </button>
        </kendo-popup>
      }
    </button>
  </div>
</nav>
